module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/91e81a26f85822490d280f29736ccc8b.png";